// Copyright (c) 2023 Visual Intelligence LP. All rights reserved.
// Note: Currently not in use.
//
import BaseService from '@core/services/base';
import Dependency, { DependencyDTO } from '@shared/models/dependency';
import Axios from 'axios';
import sortBy from 'lodash/sortBy';

// Get list of all dependencies from portal-api.
export default class DependenciesService extends BaseService<DependencyDTO, Dependency> {
  static diToken = Symbol('dependencies-service');

  constructor() {
    super({ domainArea: 'dependencies', Model: Dependency });
    this.urlPrefix = '/dependencies';
  }

  async getDependencies(): Promise<Array<Dependency>> {
    const { data } = await Axios.get<Array<DependencyDTO>>(this.urlPrefix);

    return sortBy(data, 'id').map((depDto) => new Dependency(depDto));
  }

  async getDependency(depQuery: Partial<DependencyDTO>): Promise<Dependency> {
    const { data } = await Axios.post<DependencyDTO>(this.urlPrefix, depQuery);

    return new Dependency(data);
  }

}